import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'year',
    name: 'page.numerical-serie.col-year',
  },
  {
    accessor: 'month',
    name: 'page.numerical-serie.col-month',
  },
  {
    accessor: 'counter',
    name: 'page.numerical-serie.col-counter',
  },
];
